import { render } from "./StudyFieldDetail.vue?vue&type=template&id=a65060fa&scoped=true"
import script from "./StudyFieldDetail.vue?vue&type=script&lang=js"
export * from "./StudyFieldDetail.vue?vue&type=script&lang=js"

import "./StudyFieldDetail.vue?vue&type=style&index=0&id=a65060fa&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65060fa"]])

export default __exports__